import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { AppDispatch } from "../Store";
import { smsSlice } from "../reducers/SMSSlice";
import type { ICreateSMS } from "../types/SMSTypes";
import { POST_SMS } from "./endpoints";

export const addSMS =
  (sms: ICreateSMS) =>
  async (dispatch: AppDispatch): Promise<Boolean> => {
    try {
      dispatch(smsSlice.actions.addSMSLoading());
      const res = await axios.post(
        POST_SMS,
        {
          recipientsId: sms.recipientsId,
          operatorId: sms.operatorId,
          content: sms.content,
        },
        { withCredentials: true },
      );
      dispatch(smsSlice.actions.addSMSSuccess(res.data));
      return true;
    } catch (error: any) {
      dispatch(smsSlice.actions.addSMSFailed(error.message));
      return false;
    }
  };
